import { CACHE_TIME, STALE_TIME } from '@/constants';
import { trpc } from '@/data-loaders';

export const useShowWarning = () => {
  return trpc.showWarning.useQuery(undefined, {
    retry: false,
    cacheTime: CACHE_TIME * 2,
    staleTime: CACHE_TIME,
    enabled: true,
  });
};
